module.exports = __webpack_public_path__ + "static/learn_point.86935d91.png";